import {createAsyncThunk, createEntityAdapter, createSlice} from '@reduxjs/toolkit';
import {startLoading, stopLoading} from 'app/store/utilSlice';
import {apiDel, apiGet, apiPost, apiPut} from 'app/shared-components/util/restAPI';

const availabilityRulesAdapter = createEntityAdapter({
	sortComparer: (a, b) => b.createdAt - a.createdAt
});

export const fetchAvailabilityRule = createAsyncThunk(
  "availabilityRules/fetchAvailabilityRule",
  async (id, { dispatch }) => {
	dispatch(startLoading());
	try{
      const apiName = 'CoreAPI2';
	  const path = '/x2/availabilityrules/' + id;
      const options = {
		  headers: {},
		  response: false,
	  };

	  const data = await apiGet(apiName, path, options);
	  return data;
	}finally{
	  dispatch(stopLoading());
	}
  }
);

export const fetchAvailabilityRules = createAsyncThunk(
  "availabilityRules/fetchAvailabilityRules",
  async (_, { dispatch, getState }) => {
	dispatch(startLoading());
	try{
		  const {user} = getState();
		  const apiName = 'CoreAPI2';
		  const path = '/x2/availabilityrules/byowner/User:' + user.id;
	      const options = {
			  headers: {},
			  response: false,
		  };
		  const data = await apiGet(apiName, path, options);
	     return data;
	}finally{
	  dispatch(stopLoading());
	}
  }
)

export const createAvailabilityRule = createAsyncThunk(
  "availabilityRules/createAvailabilityRule",
  async (params, { dispatch }) => {
	  dispatch(startLoading());
	  try{
	      const apiName = 'CoreAPI2';
		  const path = '/x2/availabilityrules/';
		  let body = { ...params};
	      const options = {
			  headers: {},
			  body: body,
			  response: false,
		  };

		 let availabilityRule = await apiPut(apiName, path, options);
		 return availabilityRule;
	 }finally{
		 dispatch(stopLoading());
	 }
  }
)

export const updateAvailabilityRule = createAsyncThunk(
  "availabilityRules/updateAvailabilityRule",
  async (params, { dispatch }) => {
	  dispatch(startLoading());
	  try{
	      const apiName = 'CoreAPI2';
		  const path = '/x2/availabilityrules/' + params.id;
		  let body = { 
			  ...params,
			  id: undefined,
		  };
	      const options = {
			  headers: {},
			  body: body,
			  response: false,
		  };

		 let data = await apiPut(apiName, path, options);
		 return data;
	 }finally{
		 dispatch(stopLoading());
	 }
  }
)

export const deleteAvailabilityRule = createAsyncThunk(
  "availabilityRules/deleteAvailabilityRule",
  async (id, { dispatch }) => {
	  dispatch(startLoading());
	  try{
	      const apiName = 'CoreAPI2';
		  const path = '/x2/availabilityrules/' + id;
	      const options = {
			  headers: {},
			  response: false,
		  };

		 let data = await apiDel(apiName, path, options);
		 return { id, data };
	 }finally{
		 dispatch(stopLoading());
	 }
  }
)

const availabilityRulesSlice = createSlice({
  name: "availabilityRules",
  initialState: availabilityRulesAdapter.getInitialState({
	  selectedAvailabilityRuleId: null,
  }),
  reducers: {
    setSelectedAvailabilityRuleId: (state, action) => {
      state.selectedAvailabilityRuleId = action.payload;
    },
  },
  extraReducers: builder => {
    builder
    .addCase(fetchAvailabilityRule.fulfilled, (state, action) => {
		availabilityRulesAdapter.setOne(state, action.payload);
    })
    .addCase(fetchAvailabilityRules.fulfilled, (state, action) => {
        availabilityRulesAdapter.setMany(state, action.payload);
    })
    .addCase(createAvailabilityRule.fulfilled, (state, action) => {
        availabilityRulesAdapter.addOne(state, action.payload);
    })
    .addCase(updateAvailabilityRule.fulfilled, (state, action) => {
		availabilityRulesAdapter.upsertOne(state, action.payload);
    })
    .addCase(deleteAvailabilityRule.fulfilled, (state, action) => {
      	const id = action.payload.id;
     	availabilityRulesAdapter.removeOne(state, id);
    })
  }
})

const { selectById, selectAll } = availabilityRulesAdapter.getSelectors();

export const selectAvailabilityRuleById = (id) => state => {
	return selectById(state.availabilityRules, id);
}

export const selectAllAvailabilityRules = () => state => {
	return selectAll(state.availabilityRules);
}

export const selectSelectedAvailabilityRuleId = () => state => {
	return state.availabilityRules.selectedAvailabilityRuleId;
}

export const { setSelectedAvailabilityRuleId } = availabilityRulesSlice.actions;

export default availabilityRulesSlice.reducer;